// const template = document.createElement('template');
// template.innerHTML = `
//   <style>
//     .sticky-navigation__container {
//       display: flex;
//       justify-content: space-between;
//       align-items: center;
//       width: 100%;
//     }
//     .sticky-navigation__title {
//       font-size: 14px;
//       font-weight: 600;
//       text-transform: uppercase;
//       letter-spacing: 0.03em;
//     }

//     .selected {
//       font-weight: 400;
//       text-transform: none;
//       letter-spacing: 0;
//     }
//   </style>

//   <div class="sticky-navigation__container">
//     <slot name="sticky-navigation__title" class="sticky-navigation__title"></slot>
//     <slot name="sticky-navigation__link-list" class="sticky-navigation__link-list"></slot>
//   </div>
// `


const StickyNavigation = class extends HTMLElement {
  constructor() {
    // called when an instance of the element is created, or during initialization
    super();
    this.configuredVehicle = false;
    this.selectedSection;

    this.moveToSection = this.moveToSection.bind(this);
    this.buttonClick = this.buttonClick.bind(this);
  }

  moveToSection(number) {
    const sections = [...document.querySelectorAll('section')].map(section => section.id)
    const section = document.querySelector(`#${sections[number]}`)
    section.scrollIntoView({ block: 'start', behavior: 'smooth' }) // need to add offset for sticky-header-height + header-height. can't use var()?
  }

  buttonClick(object) {
    const sectionId = object.getAttribute('data-section');
    this.selectedSection = sectionId;
    object.setAttribute('aria-current', true)
    this.moveToSection(sectionId);
    this.btns.map(button => {
      if (button !== object) {
        button.removeAttribute('aria-current')
      }
    })
  }

  connectedCallback() {
    // called when the element is inserted into the DOM
    this.btns = [...document.querySelectorAll('button.sticky-navigation__link')];
    this.btns.map(button => button.addEventListener('click', () => this.buttonClick(button)));
  }

  disconnectedCallback() {
    this.btns.map(button => button.removeEventListener())
  }

  attributeChangedCallback(attributeName, oldValue, newValue) {
    // called when an attribute is added, removed, updated or replaced

  }
}

if (!window.customElements.get("sticky-navigation")) {
  window.customElements.define("sticky-navigation", StickyNavigation);
}

export {
  StickyNavigation
}
